import React, { useState } from 'react';
import { FileTextIcon, SearchIcon, FilterIcon, DownloadIcon, MoreVerticalIcon, CheckCircleIcon, ClockIcon, AlertCircleIcon } from 'lucide-react';
import { formatNaira } from '../../utils/format';
export function PolicyRegistryModule({
  role
}: {
  role: string;
}) {
  const [filter, setFilter] = useState('All');
  const policies = [{
    id: 'SKY-2026-001',
    customer: 'Adaeze Okonkwo',
    product: 'Future Scholar Fund',
    underwriter: 'Leadway',
    date: '2026-03-10',
    status: 'Active',
    premium: 25000,
    frequency: 'Monthly'
  }, {
    id: 'SKY-2026-002',
    customer: 'Adaeze Okonkwo',
    product: 'AutoGuard',
    underwriter: 'AXA Mansard',
    date: '2026-03-12',
    status: 'Active',
    premium: 150000,
    frequency: 'Annual'
  }, {
    id: 'SKY-2026-003',
    customer: 'Adaeze Okonkwo',
    product: 'TravelGuard',
    underwriter: 'Cornerstone',
    date: '2026-03-14',
    status: 'Pending Registration',
    premium: 500,
    frequency: 'Monthly'
  }, {
    id: 'SKY-2026-004',
    customer: 'Chidi Eze',
    product: 'Income Shield',
    underwriter: 'Anchor',
    date: '2026-03-14',
    status: 'Forwarded',
    premium: 4500,
    frequency: 'Monthly'
  }, {
    id: 'SKY-2026-005',
    customer: 'Ngozi Adeyemi',
    product: 'Wellness Plan',
    underwriter: 'Hygeia',
    date: '2026-03-15',
    status: 'Pending Registration',
    premium: 15000,
    frequency: 'Monthly'
  }];
  const filteredPolicies = filter === 'All' ? policies : policies.filter(p => p.status === filter);
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'Active':
        return 'bg-emerald-100 text-emerald-700';
      case 'Pending Registration':
        return 'bg-amber-100 text-amber-700';
      case 'Forwarded':
        return 'bg-blue-100 text-blue-700';
      case 'Inactive':
        return 'bg-gray-100 text-gray-700';
      default:
        return 'bg-gray-100 text-gray-700';
    }
  };
  return <div className="space-y-6" data-id="element-504">
      <div className="flex justify-between items-center" data-id="element-505">
        <div data-id="element-506">
          <h2 className="text-2xl font-bold text-[#0D3B3B]" data-id="element-507">Policy Registry</h2>
          <p className="text-sm text-gray-500" data-id="element-508">
            Definitive log of all sold plans and their statuses.
          </p>
        </div>
        {(role === 'Super Admin' || role === 'Ops Manager') && <button className="bg-white border border-gray-200 text-[#0D3B3B] px-4 py-2 rounded-xl font-bold text-sm flex items-center gap-2 hover:bg-gray-50 transition-colors" data-id="element-509">
            <DownloadIcon className="w-4 h-4" data-id="element-510" /> Export CSV
          </button>}
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden" data-id="element-511">
        <div className="p-4 border-b border-gray-100 flex flex-col sm:flex-row gap-4" data-id="element-512">
          <div className="relative flex-1" data-id="element-513">
            <SearchIcon className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" data-id="element-514" />
            <input type="text" placeholder="Search by Plan ID, Customer, or Product..." className="w-full pl-10 pr-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#2BA89D]/20 focus:border-[#2BA89D]" data-id="element-515" />
          </div>
          <div className="flex gap-2" data-id="element-516">
            <select value={filter} onChange={e => setFilter(e.target.value)} className="px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm font-bold text-[#0D3B3B] focus:outline-none focus:ring-2 focus:ring-[#0D3B3B]" data-id="element-517">
              <option value="All" data-id="element-518">All Statuses</option>
              <option value="Active" data-id="element-519">Active</option>
              <option value="Pending Registration" data-id="element-520">Pending Registration</option>
              <option value="Forwarded" data-id="element-521">Forwarded</option>
            </select>
            <button className="px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm font-bold text-gray-600 flex items-center gap-2 hover:bg-gray-100" data-id="element-522">
              <FilterIcon className="w-4 h-4" data-id="element-523" /> Filters
            </button>
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-524">
          <table className="w-full text-left" data-id="element-525">
            <thead data-id="element-526">
              <tr className="bg-gray-50/50 text-xs uppercase tracking-wider text-gray-500 font-semibold" data-id="element-527">
                <th className="px-6 py-4" data-id="element-528">Plan ID & Date</th>
                <th className="px-6 py-4" data-id="element-529">Customer</th>
                <th className="px-6 py-4" data-id="element-530">Product & Underwriter</th>
                <th className="px-6 py-4" data-id="element-531">Contribution</th>
                <th className="px-6 py-4" data-id="element-532">Status</th>
                <th className="px-6 py-4" data-id="element-533"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-534">
              {filteredPolicies.map(policy => <tr key={policy.id} className="hover:bg-gray-50" data-id="element-535">
                  <td className="px-6 py-4" data-id="element-536">
                    <div className="text-sm font-bold text-[#0D3B3B]" data-id="element-537">
                      {policy.id}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-538">{policy.date}</div>
                  </td>
                  <td className="px-6 py-4 text-sm font-bold text-[#0D3B3B]" data-id="element-539">
                    {policy.customer}
                  </td>
                  <td className="px-6 py-4" data-id="element-540">
                    <div className="text-sm font-bold text-[#0D3B3B]" data-id="element-541">
                      {policy.product}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-542">
                      {policy.underwriter}
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-543">
                    <div className="text-sm font-bold text-[#0D3B3B]" data-id="element-544">
                      {formatNaira(policy.premium)}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-545">
                      {policy.frequency}
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-546">
                    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold ${getStatusBadge(policy.status)}`} data-id="element-547">
                      {policy.status === 'Active' ? <CheckCircleIcon className="w-3.5 h-3.5" data-id="element-548" /> : policy.status === 'Pending Registration' ? <AlertCircleIcon className="w-3.5 h-3.5" data-id="element-549" /> : <ClockIcon className="w-3.5 h-3.5" data-id="element-550" />}
                      {policy.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-551">
                    <button className="p-2 text-gray-400 hover:text-[#0D3B3B] rounded-lg hover:bg-gray-100" data-id="element-552">
                      <MoreVerticalIcon className="w-5 h-5" data-id="element-553" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}